<template>
  <DialogWrapper
    cancelBtnLabelI18nKey="admin.application.applicantList.btn.talentRecommendation.returnAndEdit"
    saveBtnLabelI18nKey="admin.application.applicantList.btn.talentRecommendation.view"
    :show.sync="isShow"
    :hideFooter="!showSameTip"
    @save="onSave"
  >
    <div v-if="showSameTip" class="same-condition-tip">
      {{ $t('admin.application.applicantList.message.sameRecommendationConditionTip') }}
    </div>
    <div v-else class="task-loading-container">
      <div class="status-tip">{{ $t('admin.application.applicantList.message.recommendationLoadTaskRunningTip') }}</div>
      <div class="task-status">
        <div v-if="runningStatus === 'start'" key="start" class="status-item">{{ $t(`${runningStatusI18nKeyPrefix}.start`) }}</div>
        <div v-else-if="runningStatus === 'review'" key="review" class="status-item">{{ $t(`${runningStatusI18nKeyPrefix}.review`) }}</div>
        <div v-else-if="runningStatus === 'search'" key="search" class="status-item">{{ $t(`${runningStatusI18nKeyPrefix}.search`) }}</div>
        <div v-else-if="runningStatus === 'read'" key="read" class="status-item">{{ $t(`${runningStatusI18nKeyPrefix}.read`) }}</div>
        <div v-else-if="runningStatus === 'rankAndSummary'" key="rankAndSummary" class="status-item">{{ $t(`${runningStatusI18nKeyPrefix}.rankAndSummary`) }}</div>
        <div v-else-if="runningStatus === 'save'" key="save" class="status-item">{{ $t(`${runningStatusI18nKeyPrefix}.save`) }}</div>
        <div v-else class="status-item">{{ finishedTaskStatus }}</div>
      </div>
      <div v-rect-loading="loading" class="loading-container"></div>
    </div>
  </DialogWrapper>
</template>

<script>
import _ from 'lodash'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import { LOAD_TASK_STATUS } from '@/constant/talentRecommendation'

export default {
  components: {
    DialogWrapper
  },
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showSameTip: {
      type: Boolean,
      default: false
    },
    taskStatus: {
      default: null
    }
  },
  data () {
    return {
      runningStatusI18nKeyPrefix: 'admin.application.applicantList.message.recommendationLoadTaskRunningStatus',
      runningStatus: 'start',
      displayList: [],
      runningStatusList: ['start', 'review', 'search', 'read', 'rankAndSummary', 'save', 'finished'],
      runningStatusTime: {
        // 变更到 目标状态 的延时，也就是前一个状态的显示时长
        // start: null
        review: [2, 6],
        search: [2, 6],
        read: [5, 10],
        rankAndSummary: [5, 10],
        save: [1, 0], // rankAndSummary 这一步很慢，这里就只等 1s
        finished: [1, 2]
      },
      runningStatusMap: {
        [LOAD_TASK_STATUS.RETRY_PENDING]: 'start',
        [LOAD_TASK_STATUS.PENDING]: 'start',
        [LOAD_TASK_STATUS.STARTED]: 'review',
        [LOAD_TASK_STATUS.FIRST_INIT]: 'review',
        [LOAD_TASK_STATUS.APPLY_HARD_CONDITION]: 'search',
        [LOAD_TASK_STATUS.APPLY_SOFT_CONDITION]: 'read',
        [LOAD_TASK_STATUS.CREATE_RECOMMENDED_INFO]: 'rankAndSummary',
        [LOAD_TASK_STATUS.RANG_AND_SUMMARY_RECOMMENDED_INFO]: 'rankAndSummary',
        [LOAD_TASK_STATUS.SAVE_RECOMMENDED_INFO]: 'save'
      }
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('change', val)
      }
    },
    finishedTaskStatus () {
      let i18nKey = 'admin.application.applicantList.message.aiRecommendSuccess'
      if (LOAD_TASK_STATUS.isFailed(this.taskStatus)) {
        i18nKey = 'admin.application.applicantList.message.aiComparisonError'
      } else if (LOAD_TASK_STATUS.isEmpty(this.taskStatus)) {
        i18nKey = 'admin.application.applicantList.message.aiRecommendNoCandidate'
      }
      return this.$t(i18nKey)
    }
  },
  created () {

  },
  destroyed () {
    this.clearDisplayList()
  },
  methods: {
    onSave () {
      if (this.loading) {
        return
      }
      this.$emit('view-same')
    },
    clearDisplayList () {
      _.forEach(this.displayList, timeoutId => clearTimeout(timeoutId))
    },
    onTaskStatusChange (reset) {
      if (reset) {
        this.runningStatus = 'start'
        this.displayList = []
        return
      }
      this.clearDisplayList()
      const runningStatus = this.runningStatusMap[this.taskStatus]
      if (!runningStatus) {
        // finished
        this.runningStatus = 'finished'
        this.displayPromise = new Promise(resolve => {
          setTimeout(() => {
            resolve()
          }, 1000)
        })
        return
      }
      // running
      const startIndex = this.runningStatusList.indexOf(this.runningStatus)
      const endIndex = this.runningStatusList.indexOf(runningStatus)
      let delay = 0
      let _resolve = null
      this.displayPromise = new Promise(resolve => (_resolve = resolve))
      _.chain(startIndex + 1).range(endIndex + 1).forEach((index) => {
        const status = this.runningStatusList[index]
        const [min, max] = this.runningStatusTime[status]
        const displayTime = max ? _.random(min * 1000, max * 1000, false) : min * 1000
        const timeoutId = setTimeout(() => {
          if (this.runningStatus === status || this.runningStatusList.indexOf(status) < this.runningStatusList.indexOf(this.runningStatus)) {
            return
          }
          this.runningStatus = status
          if (index === endIndex) {
            _resolve()
          }
        }, delay + displayTime)
        this.displayList.push(timeoutId)
        delay += displayTime
      }).value()
    },
    async displayEndStatus () {
      await this.$nextTick()
      await this.displayPromise
    }
  },
  watch: {
    show () {
      if (this.show) {
        this.onTaskStatusChange(true)
      }
    },
    taskStatus () {
      this.onTaskStatusChange()
    }
  }
}
</script>

<style lang="scss" scoped>
.task-loading-container {
  .status-tip {
    word-break: break-word;
    text-align: center;
  }
  .task-status {
    height: 40px;
    line-height: 40px;
    text-align: center;
    .status-item {
      display: inline-block;
      line-height: normal;
    }
  }
  .loading-container {
    height: 48px;
    margin-top: 10px;
  }
}
</style>
